import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout";
import {
  OverviewPage,
  InventoryPage,
  LegendariesPage,
  AdvisorPage,
  LeaderboardPage,
  AdminLayout,
  AdminDashboardPage,
  MachineConfigPage,
  AdminWalletsPage,
  ReferralSettingsPage,
} from "./pages";

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/wins" element={<LegendariesPage />} />
        <Route path="/advisor" element={<AdvisorPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="machines/:id" element={<MachineConfigPage />} />
          <Route path="wallets" element={<AdminWalletsPage />} />
          <Route path="referral" element={<ReferralSettingsPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
